import React from 'react'
import { Link } from 'react-router-dom';
import {useGroupsByCategory} from '../../../components/hooks/hooks-e-commerce/useGroups';
//import '../expogruppi.scss';

function ProdottiRegionali() {
const {groupsByCategory, loading, error} = useGroupsByCategory(9);
//console.log('in vini: ', groupsByCategory);

const elencoGruppi = groupsByCategory.map(elt => ({
    id: elt.id,
    name: elt.nome,
    collegamento: elt.collegamento,
    infoSubGroups: elt.background.infoSttoGrupo,
    imgSubGroups: elt.background.imgSottoGrupo
}));

if (loading) return <div>Caricamento...</div>;
if (error) return <div>Errore: {error}</div>;

    return (
        <section>
            <div className="grid-prodotti">
            {elencoGruppi.map(item => (
                <div className="expo-grid__item" key={item.id}>
                    <img src={require(`../../../shop/components/images/catalogo/Groups/artigiani/${item.imgSubGroups}.png`)} alt={`${item.nome} theme`} />
                    <div className="expo-item__info">
                        <p className='expo-info__title'>{item.name}</p>
                        <p>{item.infoSubGroups}</p>
                    </div>
                    <Link className="btn__link" to={item.collegamento}>
                        <button><span>Avanti </span></button>
                    </Link>
                </div>))}
            </div> 
        </section>
    )
}
export default ProdottiRegionali;
